(ns kyber.components.composite.play-pause
  (:require [re-frame.core :as re-frame]

            [kyber.components.base.button :as button]
            [kyber.styles.core :refer [gs styles->classes]]))

(def classes
  (styles->classes
   {:play-pause
    {(gs [:queries :ie])
     {:padding-right (gs [:spacing :p24])

      "& > *:first-child"
      {:margin-right (gs [:spacing :p32])}}}}))

(defn render
  [{:keys [player-state player-key]}]
  (let [event (cond
                (and (= player-state :pause) (= player-key :main-activity))
                [:activity/play-video]

                (= player-state :play)
                [:media-player/pause-media {:player-key player-key}]

                (= player-state :pause)
                [:media-player/play-media {:player-key player-key}])]
    [button/icon-button
     {:class (:play-pause :classes)
      :on-click #(re-frame/dispatch-sync event)}
     (if (= player-state :play) :pause :play)]))
